import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { Fade } from "../../components/reveal/Fade";
import "./ContactComponent.css";
import { contactPageData } from "../../portfolio.js";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";


emailjs.init("P89XoCpTb4Q62Uqyg");

const ContactData = contactPageData.contactSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      loading: false,
      recaptchaValue: "",
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleRecaptcha = (value) => {
    this.setState({ recaptchaValue: value });
  };

  componentDidUpdate(prevProps) {
    // Le reCAPTCHA est remonté (key) au changement de thème : son jeton précédent ne vaut plus.
    if (
      Boolean(prevProps.theme.isDark) !== Boolean(this.props.theme.isDark) &&
      this.state.recaptchaValue
    ) {
      this.setState({ recaptchaValue: "" });
    }
  }

  validateForm = () => {
    const { name, email, message } = this.state;

    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error("Tous les champs sont obligatoires !");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Veuillez entrer un email valide !");
      return false;
    }
    return true;
  };

  handleSubmit = (e) => {
  e.preventDefault();
  if (!this.validateForm()) return;
  const { name, email, message, recaptchaValue } = this.state;
  const time = new Date().toLocaleString();

  if (!recaptchaValue) {
      toast.error("Veuillez valider le reCAPTCHA !");
      return;
    }

  this.setState({ loading: true });

  emailjs.send(
    'service_tyba9hs',
    'template_nv0xcgx',
    {
      from_name: name,
      from_email: email,
      message: message,
      time: time
    },
    'P89XoCpTb4Q62Uqyg'
  )
  .then(
    (response) => {
      console.log('Email envoyé !', response.status, response.text);
      toast.success('Merci pour votre message ! Je reviendrai vers vous. A bientôt');
      this.setState({ name: "", email: "", message: "", loading: false });
    },
    (err) => {
      console.error('Erreur en envoyant le mail:', err);
      toast.error('Oups, une erreur est survenue. Réessayez plus tard.');
      this.setState({ loading: false });
    }
  );
};

  render() {
    const theme = this.props.theme;
    const { name, email, message, loading } = this.state;
    return (
      <div className="contact-main">
        <Header theme={theme} />
        <div className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-heading-div">
              <div className="contact-heading-img-div">
                <img
                  src={require(`../../assets/images/${ContactData["profile_image_path"]}`)}
                  alt="ilo_contact"
                />
              </div>
              <div className="contact-heading-text-div">
                <h1
                  className="contact-heading-text"
                  style={{ color: theme.text }}
                >
                  {ContactData["title"]}
                </h1>
                <p
                  className="contact-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {ContactData["description"]}
                </p>
                <SocialMedia theme={theme} />
                {/* <div className="resume-btn-div">
                  <Button
                    text="See My Resume"
                    href="/resume"
                    theme={theme}
                  />
                </div> */}
              </div>
            </div>
          </Fade>
          <Fade bottom duration={1000} distance="40px">
            <div className="address-heading-div">
              <div className="address-heading-text-div">
                <h1
                  className="address-heading-text"
                  style={{ color: theme.text }}
                >
                  Discutons de votre projet
                </h1>
                <form className="contact-form" onSubmit={this.handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Votre nom *"
                    value={name}
                    onChange={this.handleChange}
                    required
                    style={{ backgroundColor: theme.body, color: theme.text }}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Votre email *"
                    value={email}
                    onChange={this.handleChange}
                    required
                    style={{ backgroundColor: theme.body, color: theme.text }}
                  />
                  <textarea
                    name="message"
                    placeholder="Votre message *"
                    value={message}
                    onChange={this.handleChange}
                    required
                    style={{ backgroundColor: theme.body, color: theme.text }}
                  />
                  <div className="g-recaptcha">
                      <ReCAPTCHA
                      key={theme.isDark ? "dark" : "light"}
                      theme={theme.isDark ? "dark" : "light"}
                      sitekey="6LcfVJ8sAAAAAAny32ynPsuqCrXhVcEcy76J_WSx"
                      onChange={this.handleRecaptcha}
                    />
                  </div>
                  <button type="submit" className="send-button">
                    <svg 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      className="send-icon"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                    <span>{loading ? "Envoi en cours…" : "Envoyer"}</span>
                  </button>
                </form>

                <h1
                  className="address-heading-text"
                  style={{ color: theme.text }}
                >
                  {addressSection["title"]}
                </h1>
                <p
                  className="contact-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {addressSection["subtitle"]}
                </p>
                <h1
                  className="address-heading-text"
                  style={{ color: theme.text }}
                >
                  {phoneSection["title"]}
                </h1>
                <p
                  className="contact-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {phoneSection["subtitle"]}
                </p>
                {/* <div className="address-btn-div">
                  <Button
                    text="Me visiter sur Google Maps"
                    newTab={true}
                    href={addressSection.location_map_link}
                    theme={theme}
                  />
                </div> */}
              </div>
            </div>
          </Fade>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
        <ToastContainer theme={theme.isDark ? "dark" : "light"} />
      </div>
    );
  }
}

export default Contact;
